import type { ModelType, ModelStatus, GroupingMethod } from '@/types'

export const TYPE_BADGE_VARIANT: Record<ModelType, 'info' | 'seasonal'> = {
  STATIC: 'info',
  DYNAMIC: 'seasonal',
}

export const STATUS_BADGE_VARIANT: Record<
  ModelStatus,
  'success' | 'warning' | 'destructive' | 'neutral'
> = {
  ACTIVE: 'success',
  PROCESSING: 'warning',
  ERROR: 'destructive',
  PENDING: 'neutral',
}

export const GROUPING_METHOD_BADGE_VARIANT: Record<
  GroupingMethod,
  'info' | 'seasonal' | 'core' | 'neutral'
> = {
  K_MEANS: 'info',
  PERCENTILE: 'seasonal',
  CUMULATIVE_CONTRIBUTION: 'seasonal',
  ATTRIBUTE: 'core',
  MANUAL: 'neutral',
  POG_VERSION: 'seasonal',
}

export const GROUPING_METHOD_LABEL: Record<GroupingMethod, string> = {
  K_MEANS: 'K-Means',
  PERCENTILE: 'Percentile',
  CUMULATIVE_CONTRIBUTION: 'Cumulative Contribution',
  ATTRIBUTE: 'Attribute',
  MANUAL: 'Manual',
  POG_VERSION: 'POG Version',
}
